/**
 * Model configuration — `/models` (SPEC.md §6.2, D182).
 *
 * Just the page shell, same reduction as `Structure.tsx`/`Settings.tsx` (D110): every
 * section here is portable, so this only has to ask `sectionsForPage` what belongs and
 * render each through the shared registry. A dedicated page rather than a Settings card on
 * purpose (D182) — self-hosters who want no AI features at all get one clear place that's
 * entirely about it, and it's nothing special to the layout engine: a fourth built-in page,
 * fully arrangeable, renameable and deletable like any other (`layout/model.ts`).
 */

import { useCallback, useState } from "react";
import { sectionsForPage, type SectionId } from "../layout/model";
import { renderSection } from "../layout/sectionRegistry";
import { LayoutGrid, type Section } from "../layout/LayoutGrid";

export function Models() {
  const [revision, setRevision] = useState(0);
  const bump = useCallback(() => setRevision((n) => n + 1), []);

  const sections: Section[] = sectionsForPage("models")
    .map((id): Section | null => {
      const node = renderSection(id as SectionId, { refreshKey: revision, onChange: bump });
      return node ? { id, node } : null;
    })
    .filter((section): section is Section => section !== null);

  return <LayoutGrid page="models" sections={sections} onSectionsChanged={bump} />;
}
